import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100%",
    marginBottom: theme.spacing(1),
    // "& label.Mui-focused": {
    //   color: theme.palette.primary.main,
    // },
    // "& .MuiInput-underline:after": {
    //   borderBottomColor: theme.palette.primary.main,
    // },
    // "& .MuiInputBase-root": {
    //   borderRadius: 0,
    // },
    "& .MuiIconButton-root": {
      borderRadius: 0,
      // backgroundColor: "rgba(0, 0, 0, 0.1)",
      marginTop: theme.spacing(0),
      marginRight: theme.spacing(-1.6),
      height: theme.spacing(5),
      width: "40px",
    },
  },
  dialogStyle: {
    "& .MuiToolbar-root": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiTypography-root": {
        color: "white",
      },
    },
    "& .MuiPickersBasePicker-pickerView": {
      "& .MuiPickersDay-current": {
        color: theme.palette.primary.main,
      },
      "& .MuiPickersDay-daySelected": {
        backgroundColor: theme.palette.primary.main,
        color: "white",
      },
      "& .MuiPickersYearSelection-container": {
        "& .MuiPickersYear-yearSelected": {
          color: theme.palette.primary.main,
        },
      },
    },
    "& .MuiDialogActions-root": {
      "& .MuiButton-label": {
        color: theme.palette.primary.main,
      },
    },
  },
  label: {
    marginBottom: theme.spacing(1),
    color: "#000",
  },
  error: {
    color: "red",
  },
  emptyLabel: {
    color: "rgba(0, 0, 0, 0.3)",
  },
}));

export default useStyles;
